// extracted by mini-css-extract-plugin
module.exports = {"UploadPage":"UploadPage_UploadPage__LZu2R","UploadPageForm":"UploadPage_UploadPageForm__3mraU"};